<template>
  <div class="tag-wrap">
    <div class="header"><span>标签管理</span></div>
    <div class="container">
      <el-tabs destroyInactiveTabPane v-model="activeTag" style="height: 100%">
        <el-tab-pane label="一级标签" name="first" style="height: 100%">
          <first-tag
            v-if="activeTag === 'first'"
            ref="firstTag"
            :tagOptions="tagOptions"
            :operatorsOptions="operatorsOptions"
            @changeFirstTag="getFirstOptions"
          ></first-tag>
        </el-tab-pane>
        <el-tab-pane label="二级标签" name="second" style="height: 100%">
          <second-tag
            v-if="activeTag === 'second'"
            ref="secondTag"
            :tagOptions="tagOptions"
            :operatorsOptions="operatorsOptions"
          ></second-tag>
        </el-tab-pane>
        <el-tab-pane label="三级标签" name="third" style="height: 100%">
          <third-tag
            v-if="activeTag === 'third'"
            ref="thirdTag"
            @exportSuccess="exportSuccess"
            :tagOptions="tagOptions"
            :operatorsOptions="operatorsOptions"
          ></third-tag>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import FirstTag from "./components/FirstTag.vue";
import SecondTag from "./components/SecondTag.vue";
import ThirdTag from "./components/ThirdTag.vue";
import { getSelectTagList, getOperatorList } from "@/api/property.js";
export default {
  components: {
    FirstTag,
    SecondTag,
    ThirdTag,
  },

  data() {
    return {
      activeTag: "first",
      tagOptions: [],
      operatorsOptions: [],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.initSelect();
    this.getFirstOptions();
  },

  methods: {
    initSelect() {
      getOperatorList().then((res) => {
        this.operatorsOptions = res.data;
      });
    },
    getFirstOptions() {
      getSelectTagList({ dataLevel: 1 }).then((res) => {
        this.tagOptions = res.data;
      });
    },
    exportSuccess() {
      this.getFirstOptions();
    },
  },
};
</script>

<style lang="less" scoped>
.tag-wrap {
  border-radius: 4px;
  margin: 16px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
  height: calc(~"100% - 38px");
  background: #ffffff;
  .header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: rgba(24, 144, 255, 1);
    padding-left: 25px;
  }
  .container {
    height: calc(~"100% - 104px");
    padding: 16px 24px;
    /deep/ .el-tabs__content {
      height: 100%;
    }
  }
}
</style>
